import {BagSvg} from './BagSvg';
import {WaySvg} from './WaySvg';
import {ListSvg} from './ListSvg';
import {LogoSvg} from './LogoSvg';
import {CardSvg} from './CardSvg';
import {InfoSvg} from './InfoSvg';
import {GiftSvg} from './GiftSvg';
import {ExitSvg} from './ExitSvg';
import {CopySvg} from './CopySvg';
import {StarSvg} from './StarSvg';
import {PlusSvg} from './PlusSvg';
import {SortSvg} from './SortSvg';
import {MailSvg} from './MailSvg';
import {UserSvg} from './UserSvg';
import {SaveSvg} from './SaveSvg';
import {CheckSvg} from './CheckSvg';
import {HeartSvg} from './HeartSvg';
import {MinusSvg} from './MinusSvg';
import {TicketSvg} from './TicketSvg';
import {DeleteSvg} from './DeleteSvg';
import {GoBackSvg} from './GoBackSvg';
import {InCartSvg} from './InCartSvg';
import {BasketSvg} from './BasketSvg';
import {MapPinSvg} from './MapPinSvg';
import {EyeOffSvg} from './EyeOffSvg';
import {PencilSvg} from './PencilSvg';
import {BurgerSvg} from './BurgerSvg';
import {FilterSvg} from './FilterSvg';
import {SignOutSvg} from './SignOutSvg';
import {LogoBigSvg} from './LogoBigSvg';
import {FiltersSvg} from './FiltersSvg';
import {ViewAllSvg} from './ViewAllSvg';
import {CalendarSvg} from './CalendarSvg';
import {HeartBigSvg} from './HeartBigSvg';
import {ShippingSvg} from './ShippingSvg';
import {CanceledSvg} from './CanceledSvg';
import {AgeCheckSvg} from './AgeCheckSvg';
import {SortingBySvg} from './SortingBySvg';
import {ModalMailSvg} from './ModalMailSvg';
import {OrderPlusSvg} from './OrderPlusSvg';
import {PhoneCallSvg} from './PhoneCallSvg';
import {SearchHeaderSvg} from './SearchSvg';
import {DeliveredSvg} from './DeliveredSvg';
import {InWishlistSvg} from './InWishlistSvg';
import {RightArrowSvg} from './RightArrowSvg';
import {OrderMinusSvg} from './OrderMinusSvg';
import {SmartphoneSvg} from './SmartphoneSvg';
import {NewPromocodeSvg} from './NewPromocodeSvg';
import {EmailVerifiedSvg} from './EmailVerifiedSvg';
import {RememberCheckSvg} from './RememberCheckSvg';
import {PhoneVerifiedSvg} from './PhoneVerifiedSvg';
import {CheckPromocodeSvg} from './CheckPromocodeSvg';
import {BestSellerHeartSvg} from './BestSellerHeartSvg';

// Tab Icons
import {HomeSvg} from './tabs/HomeSvg';
import {OrderSvg} from './tabs/OrderSvg';
import {SearchSvg} from './tabs/SearchSvg';
import {ProfileSvg} from './tabs/ProfileSvg';
import {WishlistSvg} from './tabs/WishlistSvg';

export const svg = {
  BagSvg,
  WaySvg,
  HomeSvg,
  ListSvg,
  UserSvg,
  CardSvg,
  GiftSvg,
  InfoSvg,
  ExitSvg,
  SortSvg,
  CopySvg,
  LogoSvg,
  SaveSvg,
  StarSvg,
  PlusSvg,
  MailSvg,
  MinusSvg,
  OrderSvg,
  HeartSvg,
  CheckSvg,
  TicketSvg,
  DeleteSvg,
  FilterSvg,
  BasketSvg,
  BurgerSvg,
  InCartSvg,
  SearchSvg,
  PencilSvg,
  MapPinSvg,
  EyeOffSvg,
  GoBackSvg,
  FiltersSvg,
  SignOutSvg,
  LogoBigSvg,
  ViewAllSvg,
  ProfileSvg,
  CalendarSvg,
  AgeCheckSvg,
  CanceledSvg,
  WishlistSvg,
  HeartBigSvg,
  ShippingSvg,
  DeliveredSvg,
  OrderPlusSvg,
  PhoneCallSvg,
  SortingBySvg,
  ModalMailSvg,
  SmartphoneSvg,
  OrderMinusSvg,
  InWishlistSvg,
  RightArrowSvg,
  SearchHeaderSvg,
  NewPromocodeSvg,
  EmailVerifiedSvg,
  PhoneVerifiedSvg,
  RememberCheckSvg,
  CheckPromocodeSvg,
  BestSellerHeartSvg,
};
